import { TextBlock } from '../../../Atoms/Text';
import { ClientScore } from '../../../../types/advise';
import { ClientScoreBar } from './ClientScoreBar';
import { responsesLabel } from './SupplierScoring.calc';

/** The client average as a read-only purple bar, with how many clients it comes from. */
export const ClientAverageBar = ({ clientScore }: { clientScore?: ClientScore }) => (
  <div>
    <ClientScoreBar
      score={clientScore?.average ?? 0}
      label={clientScore ? `Client average ${clientScore.average}` : 'No client responses'}
    />
    <TextBlock
      size="xs"
      color={clientScore ? 'purple' : 'grey6'}
      className="mt-1">
      {clientScore ? responsesLabel(clientScore.scores.length) : 'No responses yet'}
    </TextBlock>
  </div>
);
